const rules = {
  tours: ['toursPerSite', 'tours per site'],
  languages: ['languagesPerTour', 'languages per tour'],
  points: ['pointsPerTour', 'stops per tour'],
  images: ['imagesPerPoint', 'images per stop'],
};

export function limitReason(state, kind, amount = 1, countOverride) {
  if (!state) return 'Customer limits could not be loaded. Retry before adding content.';
  const p = state.package;
  if (!p) return 'Assign a customer type before adding content.';
  const [field, label] = rules[kind];
  const count = countOverride ?? state.usage?.[kind];
  if (!Number.isInteger(p[field]) || p[field] < 1 || !Number.isInteger(count) || count < 0)
    return 'Customer limits are invalid. Contact your administrator.';
  return count + amount > p[field]
    ? `${p.name || `Type ${p.code}`} allows ${p[field]} ${label}. Remove content or ask an administrator to change the entitlement.`
    : '';
}

export function contentLimitReason(state) {
  return limitReason(state, 'languages', 0) || limitReason(state, 'points', 0)
    || limitReason(state, 'images', 0, state?.usage?.maxImages);
}

export function limitsSummary(state) {
  if (!state?.package) return limitReason(state, 'tours');
  const p = state.package;
  const content = Object.entries(rules).map(([, [field, label]]) => `${p[field]} ${label}`).join(' · ');
  const narration = state.narration?.standard;
  if (narration) {
    const used = Math.ceil(((narration.usedSeconds || 0) + (narration.reservedSeconds || 0)) / 60);
    const limit = Math.ceil((narration.limitSeconds || 0) / 60);
    const reset = narration.periodEndUtc
      ? `; resets ${new Intl.DateTimeFormat(undefined, { day: 'numeric', month: 'short' }).format(new Date(narration.periodEndUtc))}`
      : '';
    return `${p.name || `Type ${p.code}`}: ${content} — Narration ${used} of ${limit} minutes used${reset}`;
  }
  return `${p.name || `Type ${p.code}`}: ` + Object.entries(rules).map(([, [field, label]]) =>
    `${p[field]} ${label}`).join(' · ');
}
